var _rect, _rect2, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconChoosePayment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 4,
    width: 48,
    height: 48,
    rx: 24,
    fill: "#D1FADF"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 4,
    width: 48,
    height: 48,
    rx: 24,
    stroke: "#ECFDF3",
    strokeWidth: 8
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.3333 26.334L25 30.334H28L27.6667 33.0007L31 29.0007H28L28.3333 26.334Z",
    stroke: "#039855",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M36 23V21C36 19.897 35.103 19 34 19H21C19.346 19 18 20.346 18 22V34C18 36.201 19.794 37 21 37H36C37.103 37 38 36.103 38 35V25C38 23.897 37.103 23 36 23ZM21 21H34V23H21C20.7425 22.9885 20.4994 22.8781 20.3213 22.6918C20.1431 22.5055 20.0437 22.2577 20.0437 22C20.0437 21.7423 20.1431 21.4945 20.3213 21.3082C20.4994 21.1219 20.7425 21.0115 21 21ZM36 35H21.012C20.55 34.988 20 34.805 20 34V24.815C20.314 24.928 20.647 25 21 25H36V35Z",
    fill: "#039855"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconChoosePayment);
export default __webpack_public_path__ + "static/media/icon-choose-payment.440561abb701646b40943427cb548227.svg";
export { ForwardRef as ReactComponent };